'use client';
import { getQueryClient } from '@jci/components/reactQueryClient';
import { QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from 'next-auth/react';
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';

export const ClientProviders = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [queryClient] = useState(() => getQueryClient());

  return (
    <SessionProvider>
      <QueryClientProvider client={queryClient}>
        {children}
        <ToastContainer />
      </QueryClientProvider>
    </SessionProvider>
  );
};
